import React, { useCallback, useEffect, useState } from 'react';

import Tooltip from 'components/common/Tooltip';
import FeatureFeedback from 'components/FeatureFeedback';
import { SEARCH_PAGE } from 'constants/amethystPageTypes';
import { cn } from 'helpers/classnames';

// eslint-disable-next-line css-modules/no-unused-class
import css from 'styles/containers/search.scss';

interface SearchFeedbackBottomProps {
  className?: string;
  testId: (id: string) => string;
}

export default function SearchFeedbackBottom({ className, testId }: SearchFeedbackBottomProps) {
  const [tooltipVisible, setTooltipVisible] = useState(false);

  const closeFeedback = useCallback(() => setTooltipVisible(false), []);

  const handleKeydown = useCallback(
    (e: KeyboardEvent) => {
      if (e.key === 'Escape' || e.key === 'Esc') {
        closeFeedback();
      }
    },
    [closeFeedback]
  );

  useEffect(() => {
    window.addEventListener('keydown', handleKeydown);
    return () => {
      window.removeEventListener('keydown', handleKeydown);
    };
  }, [handleKeydown]);

  const onClick = () => setTooltipVisible(v => !v);

  return (
    <div className={cn(css.searchFeedbackRow, className)}>
      <button
        type="button"
        className={cn(css.searchFeedbackButton, 'zappos:after:brightness-0')}
        onClick={onClick}
        aria-expanded={tooltipVisible ? 'true' : 'false'}
        id="feedbackRequest"
        data-test-id={testId('searchFeedbackButton')}
      >
        Find what you're looking for?
      </button>

      <div className={css.searchFeedbackTooltipWrap}>
        <Tooltip
          tooltipId="searchFeedback"
          tooltipClassName={css.searchFeedbackTooltip}
          contentClassName={css.searchFeedbackTooltipContent}
          mobileWrapper={css.searchFeedbackMobileWrapper}
          mobileClass={css.searchFeedbackMobileEncompass}
          direction="left"
          clickable
          clickOpen={tooltipVisible}
          content={
            <>
              <header>
                <h3 className="body-l-bold mx-5 mb-3 mt-[14px] text-left" id="feedBackTitle">
                  Let us know your feedback!
                </h3>
                <button type="button" value="close" className={css.searchFeedbackClose} aria-label="Close" onClick={closeFeedback}></button>
              </header>
              {/* FeatureFeedback has many optional style props; provide the required ones explicitly and rely on defaults for the rest */}
              <FeatureFeedback
                isYesNoOnly
                autoOpenOnYesNoClick
                completionMessage="Thank you!"
                feedbackQuestion="Did you find what you were looking for?"
                feedbackType="SEARCH_RELEVANCY_FEEDBACK"
                pageType={SEARCH_PAGE}
                source="search"
                surveyUrl={''}
                wrapperClass={css.searchFeedbackWrapper}
                yesNoWrapperClass={css.searchFeedbackYesNoWrapper}
                completionMessageClass=""
                noButtonClass=""
                responseClass=""
                responseButtonWrapperClass=""
                yesButtonClass=""
              />
            </>
          }
        ></Tooltip>
      </div>
    </div>
  );
}
